(function () {
  "use strict";

  HomeCtrlResolver.$inject = ['accountInfoService', '$location', '$q', '$route', 'homeResource', 'Validation', 'errorHandler', 'refreshSession', 'Auth', 'leftMenuService', '$window', 'mtypes'];
angular
  .module('trainerWebApp.resources')
  .factory('HomeCtrlResolver', HomeCtrlResolver);

  function HomeCtrlResolver(accountInfoService, $location, $q, $route, homeResource, Validation, errorHandler, refreshSession, Auth, leftMenuService, $window, mtypes) {

    return function () {
      var deferred = $q.defer();
      var pageName = $route.current.params.pageName || $route.current.pageName;

      var successCb = function (result) {
        Auth.getPrivilegesPromise().then(function() {
          deferred.resolve(result);
        });
      };

      switch ($window.mfConfig.accountStatus) {
        case mtypes.accountStatus.cancelled:
        case mtypes.accountStatus.nonPayment:
        case mtypes.accountStatus.trialExpired:
          accountInfoService.redirect();
          deferred.resolve();
          return deferred.promise;
      }

      if(leftMenuService.featureEnabled()) {
        $window.location.href = leftMenuService.redirectUrl;
        deferred.reject(false);
        return deferred.promise;
      }

      if (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test($window.navigator.userAgent.toLowerCase())) {
        $window.location.href = '/TrainerM/#/users';
        deferred.reject(false);
        return deferred.promise;
      }

      // let the controller handle the validate
      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      if (!pageName || pageName == 'home') {
        refreshSession.refresh(null, function() {
          homeResource.load(successCb, errorHandler.defaultServerErrorHandler());
        });
      }

      return deferred.promise;
    };
  }

})();
